import dayjs from "dayjs";
import { Appointment, APPOINTMENT_STATUS, MODES_OF_APT } from "@elixir/types";
import {
  cancelAppointmentReminders,
  sendAppointmentCommunication,
  updateAppointment,
} from "../../utils/bridges/methods";
import { logAndGetErrorResponse } from "../error";
import { ControllerReturnType } from "../types";
import { generateAppointmentToken } from "./generate-appointment-token";
import { convertDateToFirestoreTimestamp, isoStringToTimestamp } from "../../firestore/utils";
import { MESSAGE_TYPE } from "../../utils/bridges/events/types";
import { AptActivityType, trackAppointmentActivity } from "./appointment-activity";

export default async function scheduleAppointment({
  appointment,
  action,
  endTime,
  mode,
  startTime,
}: {
  appointment: Pick<
    Appointment,
    "aid" | "clinic_id" | "doctor_oid" | "channel"
  >;
  startTime: string;
  endTime: string;
  action: "SCHEDULE" | "CHECK_IN";
  mode?: MODES_OF_APT;
}): Promise<ControllerReturnType> {
  try {
    const { aid, clinic_id, doctor_oid } = appointment;
    let token: number | undefined = undefined;

    if (action === "CHECK_IN") {
      token = await generateAppointmentToken({
        clinicId: clinic_id,
        doctorId: doctor_oid,
        date: new Date(startTime),
      });
    }

    const date = convertDateToFirestoreTimestamp(
      dayjs(startTime).startOf("day").toDate()
    );

    await updateAppointment({
      data: {
        start_time: isoStringToTimestamp(startTime),
        end_time: isoStringToTimestamp(endTime),
        date,
        full_date: convertDateToFirestoreTimestamp(new Date(startTime)),
        status:
          action === "SCHEDULE"
            ? APPOINTMENT_STATUS.BOOKED
            : APPOINTMENT_STATUS.CHECKED_IN,
        token,
        mode,
      },
      aid,
    });


    sendScheduledAptMessages({ aid });
    trackAppointmentActivity({
      aid,
      activity: AptActivityType.CREATED,
    });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}

async function sendScheduledAptMessages({ aid }: { aid: string }) {
  await cancelAppointmentReminders({ aid });
  await sendAppointmentCommunication({
    aid,
    data: { msg_type: MESSAGE_TYPE.BOOK_APPPOINTMENT },
  });

  setTimeout(() => {
    sendAppointmentCommunication({
      aid,
      data: { msg_type: MESSAGE_TYPE.SCHEDULE_APT_REMIDNER },
    });
  }, 2000);
}
